import { render, staticRenderFns } from "./Mazer.vue?vue&type=template&id=5acfb7bc&scoped=true&"
import script from "./Mazer.vue?vue&type=script&lang=js&"
export * from "./Mazer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfb7bc",
  null
  
)

export default component.exports